import { Component, OnInit, Inject, PLATFORM_ID, OnDestroy } from '@angular/core';
import { MktContentStorageService } from 'src/app/core/services/mkt-content-storage.service';
import { ActivatedRoute } from '@angular/router';
import { combineLatest, Subscription } from 'rxjs';
import { MktEnvironmentService } from 'src/app/core/services/mkt-environment.service';
import { DOCUMENT, isPlatformServer } from '@angular/common';
import { MktCommonModule } from 'src/app/common/mkt-common.module';

@Component({
  selector: 'app-feature-section',
  templateUrl: './feature-section.component.html',
  styleUrls: ['./feature-section.component.scss'],
  standalone: true,
  imports: [MktCommonModule]
})
export class FeatureSectionComponent implements OnInit, OnDestroy {

  featureContent: any = null;
  isMobile = false;
  imageBasePath: String = '';
  routeSub: Subscription = new Subscription();

  slideConfig = {
    'slidesToShow': 5,
    'slidesToScroll': 1,
    'nextArrow': `<a id="nextSlide" href="javascript:;" aria-label="next explore other citi credit cards" class=\'nav-btn next-slide\'></a>`,
    'prevArrow': `<a id="prevSlide" href="javascript:;" aria-label="previous explore other citi credit cards" class=\'nav-btn prev-slide\'></a>`,
    'infinite': false,
    'swipe': false,

    'responsive': [
      {
        'breakpoint': 767,
        'settings': {
          'slidesToShow': 3,
          'slidesToScroll': 1,
        }
      },
      {
        'breakpoint': 768,
        'settings': {
          'slidesToShow': 4,
          'slidesToScroll': 1,
        }
      },

      {
        'breakpoint': 1024,
        'settings': {
          'slidesToShow': 4,
          'slidesToScroll': 1,
        }
      }

    ]

  };
  swipeCoord: [number, number];
  swipeTime: number;
  sub: Subscription = new Subscription();
  category: string;
  afcCode: string;
  intcCode: string;
  flowId: string;

  constructor(
    private _mktContentStorageService: MktContentStorageService,
    private mktEnvironmentService: MktEnvironmentService,
    @Inject(PLATFORM_ID) private platformId: string,
    @Inject(DOCUMENT) private _document,
    private route: ActivatedRoute) {
    this.imageBasePath = this.mktEnvironmentService.getEnvironmentVar('cardsmkrHostName');
    this.sub.add(combineLatest([
      this.route.params,
      this.route.queryParams
    ]).subscribe((params) => {
      this.category = params[1]['category'] || "";
      this.afcCode = params[1]['afc'] || "";
      this.intcCode = params[1]['intc'] || "";
      this.flowId = params[1]['flowId'] || "";
    }));
  }

  ngOnInit(): void {
    if (window.screen.width < 768) { this.isMobile = true; }
    this.getFeatureSectionContent();
  }

  ngOnDestroy() {
    this.routeSub.unsubscribe();
    this.sub.unsubscribe();
  }

  private getFeatureSectionContent() {
    this.routeSub = combineLatest([
      this.route.params,
    ]).subscribe(params => {
      const cardName = params[0]['cardName'].replace(/\./g, '');
      // Try to get card pricing details
      const mainPdpContentObject = this._mktContentStorageService.get('Product_Detail_Pages', 'copy', cardName, undefined);
      if (!mainPdpContentObject) {
        return;
      }
      const featureContent = JSON.parse(mainPdpContentObject['featureSection']);
      if (!featureContent || !featureContent.featureActive) { return; }
      this.featureContent = {
        ...featureContent,
        features: featureContent.features.map(feature => {
          feature.imagePath =  `${this.imageBasePath}${feature.imagePath}`;
          feature.link =  this.setParamsToURL(feature.link, `intc=${this.intcCode},afc=${this.afcCode},flowId=${this.flowId}`);
          return feature;
        }
        )
      };
    });
  }

  private setParamsToURL = (url, value) => {
    if (isPlatformServer(this.platformId))  return url;
    const newUrl = new URL(url, origin);
    newUrl.host = window.location.host;
    newUrl.protocol = window.location.protocol;
    const params = value.split(",");
    params.map(async value => {
      let keyValues = value.split("=");
      keyValues[1] != '' && newUrl.searchParams.set(keyValues[0], keyValues[1]);
    })
    return newUrl;
  };

  removeSlide() {
    this.featureContent.features.length = this.featureContent.features.length - 1;
  }

  focus(position) {
    const instance = setTimeout(() => {
      const slickActiveRef = this._document.querySelectorAll('.slick-active');
      const index = position === 'next' ? (slickActiveRef.length - 1) : 0;
      const selectAnchor = slickActiveRef[index].firstElementChild.getElementsByTagName('a')[0];
      selectAnchor.focus();
      clearTimeout(instance);
    }, 600);
  }

  private removeTabIndex() {
    const instance = setTimeout(() => {
      this._document.querySelectorAll('.slide').forEach(item => {
        item.removeAttribute('tabindex');
      });
      clearTimeout(instance);
    }, 100);
  }

  swipe(e, when) {
    const coord: [number, number] = [
      e.changedTouches[0].clientX,
      e.changedTouches[0].clientY,
    ];
    const time = new Date().getTime();
    if (when === 'start') {
      this.swipeCoord = coord;
      this.swipeTime = time;
    } else if (when === 'end') {
      const direction = [
        coord[0] - this.swipeCoord[0],
        coord[1] - this.swipeCoord[1],
      ];
      const duration = time - this.swipeTime;
      // console.log((direction[0] - direction[1]) > 0 ? 'ltr' : 'rtl');

      if (
        duration < 1000 && //
        Math.abs(direction[0]) > 30 && // Long enough
        Math.abs(direction[0]) > Math.abs(direction[1] * 3)
      ) {
        this._document.getElementById('nextSlide').click();
        this.removeTabIndex();
        this.focus('previous');
      }
    }
  }

  slickInit() {
    setTimeout(()=>{
    this._document.getElementById('nextSlide')?.addEventListener('click', () => this.focus('next'));
    this._document.getElementById('prevSlide')?.addEventListener('click', () => this.focus('previous'));
    this.removeTabIndex();
    },0);
  }

  afterChange() {
    this.removeTabIndex();
  }
}
